/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Metadata_NoneInputs */



/**
* | output |
* | --- |
* | "No metadata found" |
*
* @param {Transcript_Export_Metadata_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_metadata_none = /** @type {((inputs?: Transcript_Export_Metadata_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Metadata_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune metadonnee trouvee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Metadaten gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun metadato trovato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные не найдены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई मेटाडेटा नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum metadado encontrado")
	return /** @type {LocalizedString} */ ("No metadata found")
});